import React from 'react';

import { parseTextWithEmoji } from 'widget/utils/emoji';

import EmojiImg from './EmojiImg';

export type EmojiTextProps = {
  text: string;
};

const EmojiText: React.FC<EmojiTextProps> = ({ text }) => {
  const segments = React.useMemo(() => parseTextWithEmoji(text), [text]);

  return (
    <>
      {segments.map((segment, index) =>
        segment.type === 'emoji' ? (
          <EmojiImg key={index} emoji={segment.value} />
        ) : (
          segment.value
        )
      )}
    </>
  );
};

export default React.memo(EmojiText);
